<template>
  <div class="position-relative">
    <input
      v-model="item.value"
      :required="item.required"
      :type="item.type"
      class="form-control"
      :id="'ag-formEl_' + item.name"
      @input="onInput"
    />
    <a href="javascript:;" class="generate-btn" @click="generate">Generate</a>
    <a
      href="javascript:;"
      v-if="item.value"
      class="generate-btn copy-btn"
      @click="copy"
      >{{$t("copy")}}</a
    >
  </div>
</template>

<script>
import generator from "generate-password";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    generate() {
      const password = generator.generate({
        length: 10,
        numbers: true,
        strict: true,
        symbols: true,
      });
      this.item.value = password;
      this.$emit("input", password);

      // this.item.value = Math.random().toString(36).slice(-8);
      // this.$emit("input", this.item.value);
    },
    onInput() {
      this.$emit("input", this.item.value);
    },
    copy() {
      navigator.clipboard.writeText(this.item.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.generate-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 14px;

  &.copy-btn {
    right: 80px;
  }
}
</style>
